<template>
	<v-dialog max-width="600px" v-model="dialogModel">
		<v-card>
			<v-card-title class="headline">
				<span v-if="isEdit">{{ $t("message.editBank") }}</span>
				<span v-else>
					<Address></Address>
					{{ $t("message.addBank") }}
				</span>
			</v-card-title>
			<v-card-text>
				<v-form ref="bankForm" v-model="bankForm.valid">
					<v-container grid-list-md pt-0>
						<v-layout row wrap>
							<!-- <v-flex xs12>
								<v-checkbox v-model="bankForm.zelle" label="Zelle"></v-checkbox>
							</v-flex> -->
							<v-flex md12 xs12>
								<v-text-field
									:error-messages="errors.collect('bank_name')"
									data-vv-name="bank_name"
									:label="$t('message.paymentMethod')"
									prepend-icon="mdi-bank"
									required
									type="text"
									v-model="bankForm.bank_name"
									v-validate="'required'"
								></v-text-field>
							</v-flex>
							<v-flex xs4>
								<v-select
									:error-messages="errors.collect('account_type')"
									data-vv-name="account_type"
									:items="accountType"
									:label="$t('message.currency')"
									prepend-icon="mdi-cash-multiple"
									required
									v-model="bankForm.account_type"
									v-validate="'required'"
								></v-select>
							</v-flex>
							<v-flex xs8>
								<v-text-field
									:error-messages="errors.collect('account_number')"
									data-vv-name="account_number"
									:label="$t('message.accountNumberEmailPhone')"
									prepend-icon="mdi-account-card-details"
									required
									type="text"
									v-model="bankForm.account_number"
									v-validate="'required'"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									:error-messages="errors.collect('owner_full_name')"
									data-vv-name="owner_full_name"
									:label="$t('message.ownerName')"
									prepend-icon="mdi-account"
									required
									type="text"
									v-model="bankForm.owner_full_name"
									v-validate="'required'"
								></v-text-field>
							</v-flex>
							<v-flex xs4>
								<v-select
									:error-messages="errors.collect('owner_idenfication_type')"
									data-vv-name="owner_idenfication_type"
									:items="documentType"
									:label="$t('message.documentType')"
									prepend-icon="mdi-file-document"
									required
									v-model="bankForm.owner_idenfication_type"
									v-validate="'required'"
								></v-select>
							</v-flex>
							<v-flex xs8>
								<v-text-field
									:error-messages="errors.collect('owner_idenfication')"
									data-vv-name="owner_idenfication"
									:label="$t('message.ownerDocument')"
									prepend-icon="mdi-file-document-box"
									required
									type="text"
									v-model="bankForm.owner_idenfication"
									v-validate="'required'"
								></v-text-field>
							</v-flex>
						</v-layout>
					</v-container>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn outline @click="onClose" color="error" small>{{
					$t("message.close")
				}}</v-btn>
				<v-btn outline @click="onSave" color="primary" small>{{
					$t("message.save")
				}}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { accountType, documentType } from "../../constants/constants";

const initBank = {
	zelle: false,
	account_number: null,
	account_type: null,
	bank_name: null,
	owner_full_name: null,
	owner_idenfication: null,
	owner_idenfication_type: null,
	valid: false,
};

export default {
	name: "bankManage",
	props: {
		dialog: {
			required: false,
			default: false,
		},
		isEdit: {
			required: false,
			default: false,
		},
	},
	data() {
		return {
			bankForm: initBank,
			accountType,
			documentType,
			dialogModel: this.dialog,
		};
	},
	methods: {
		resetForm() {
			//this.bankForm = initBank;
			this.$validator.reset();
			this.$refs.bankForm.reset();
		},
		onClose() {
			this.$emit("update:dialog", false);
			this.resetForm();
		},
		async onSave() {
			try {
				const valid = await this.$validator.validateAll();
				if (valid) {
					this.$emit("on-save", {
						...this.bankForm,
						zelle: this.bankForm.zelle ? 1 : 0,
					});
					this.$emit("update:dialog", false);
				}
			} catch (err) {
				console.error(err);
			}
		},
		setValue(bank) {
			this.bankForm = Object.assign({}, bank);
		},
	},
	watch: {
		dialog(value) {
			this.dialogModel = value;
		},
		dialogModel(value) {
			this.$emit("update:dialog", value);
		},
	},
};
</script>

<style></style>
